import AppFile from '../objects/file';

export default class AppDropzone {
    constructor () {
        let self = this;
        $('form[data-toggle=dropzone]').each(function () {
            self.init($(this));
        });
    }

    init ($form) {
        let self = this;

        let template = Handlebars.templates[$form.attr('data-file-template')];
        let dataUrl = $form.attr('data-uploaded-files');
        let $container = $($form.attr('data-file-container'));
        let $totalProgress = $($form.attr('data-total-progress'));
        let $listWrapper = $container.parents('.list-wrapper');
        let $filters = $listWrapper.find('[data-filter]');
        let deleteUrl = $form.attr('data-delete-url');
        let deliverUrl = $form.attr('data-deliver-url');
        let $mediaState = $('#media-state');

        $mediaState.on('change', function () {
            if ($mediaState.val()) {
                $mediaState.removeClass('is-invalid');
            } else {
                $mediaState.addClass('is-invalid');
            }
        });

        $filters.on('click', function (e) {
            e.preventDefault();
            $filters.removeClass('btn-warning');
            $(this).addClass('btn-warning');
            self.filterList($form);
        });

        $.getJSON(dataUrl, function (files) {
            $.each(files, function () {
                let file = new AppFile(this.id, this.name, AppFile.STATUS_UPLOADED(), false, this.custom_properties, this.url_thumb, deleteUrl, deliverUrl);
                let $file = self.renderFile(template, file);
                $file.prependTo($container);
            });
            self.itemAdded($form);
        });

        $form.dropzone({
            timeout: 5 * 60 * 1000,
            parallelUploads: 2,
            uploadMultiple: false,
            chunking: false,
            createImageThumbnails: false,
            autoProcessQueue: true,
            autoQueue: true,
            clickable: true,
            previewsContainer: false,

            accept: function (file, done) {
                if ($mediaState.val()) {
                    $mediaState.removeClass('is-invalid');
                    done();
                } else {
                    $mediaState.addClass('is-invalid');
                    done({
                        message: 'No media-state selected.',
                    });
                }
            },
            addedfile: function (dzFile) {
                window.onbeforeunload = function (e) {
                    e.returnValue = 'upload in progress';

                    return 'upload in progress';
                };

                let file = new AppFile(null, dzFile.name, AppFile.STATUS_WAIT(), 0);
                let $file = self.renderFile(template, file);
                dzFile.element = $file.prependTo($container);
                dzFile.mediaState = $('#media-state').val();
                self.itemAdded($form);
                this.options.totalprogress(this);
            },
            processing: function (dzFile) {
                let file = new AppFile(null, dzFile.name, AppFile.STATUS_PROGRESS(), 0);
                let $file = self.renderFile(template, file);
                dzFile.element.replaceWith($file);
                dzFile.element = $file;
                self.itemAdded($form);
            },
            sending: function (dzFile, xhr, formData) {
                formData.append('state', dzFile.mediaState);
            },
            uploadprogress: function (dzFile, progress) {
                let file = new AppFile(null, dzFile.name, AppFile.STATUS_PROGRESS(), progress);
                let $file = self.renderFile(template, file);
                dzFile.element.replaceWith($file);
                dzFile.element = $file;
                self.itemAdded($form);
            },
            success: function (dzFile, response) {
                let file = new AppFile(response.id, response.name, AppFile.STATUS_SUCCESS(), false, response.custom_properties, response.url_thumb, deleteUrl, deliverUrl);
                let $file = self.renderFile(template, file);
                dzFile.element.replaceWith($file);
                dzFile.element = $file;
                self.itemAdded($form);
                this.options.totalprogress(this);
            },
            error: function (dzFile, error) {
                let file = new AppFile(null, dzFile.name, AppFile.STATUS_ERROR(), dzFile.upload.progress);
                file.error = error.message;
                let $file = self.renderFile(template, file);
                dzFile.element.replaceWith($file);
                dzFile.element = $file;
                self.itemAdded($form);
                this.options.totalprogress(this);
            },
            totaluploadprogress: function (uploadProgress) {
                if (uploadProgress >= 100) {
                    window.onbeforeunload = null;
                }
            },
            totalprogress: function (dropzone) {
                let count = dropzone.files.length;
                let percent = 100 / count;

                $totalProgress.html('');
                $.each(dropzone.files, function () {
                    let status = this.status;
                    let classes = 'progress-bar-info progress-bar-striped';
                    switch (status) {
                    case 'success':
                        classes = 'progress-bar-success';
                        break;
                    case 'error':
                        classes = 'progress-bar-danger';
                        break;
                    }
                    $totalProgress.append('<div class="progress-bar ' + classes + '" style="width:' + percent + '%;"></div>');
                });
            },
        });
        $form.addClass('dropzone');

        // Dropbox Picker
        if (Dropbox.isBrowserSupported()) {
            let $dropboxChooser = $('#dropbox-chooser');

            $dropboxChooser
                .removeClass('disabled')
                .removeClass('btn-dark')
                .addClass('btn-dropbox');

            $dropboxChooser.on('click', function (e) {
                e.preventDefault();

                Dropbox.choose({
                    success: function (dbFiles) {
                        dbFiles.forEach(dbFile => {
                            let $element;
                            $.ajax({
                                url: $dropboxChooser.attr('data-url'),
                                method: 'POST',
                                dataType: 'json',
                                contentType: 'application/json',
                                data: JSON.stringify({
                                    file: dbFile,
                                    state: $('#media-state').val(),
                                }),
                                beforeSend: function () {
                                    let file = new AppFile(null, dbFile.name, AppFile.STATUS_PROGRESS(), null);
                                    $element = self.renderFile(template, file);
                                    $element.prependTo($container);
                                    self.itemAdded($form);
                                },
                            }).done(function (response) {
                                let file = new AppFile(response.id, response.name, AppFile.STATUS_SUCCESS(), false, response.custom_properties, response.url_thumb, deleteUrl, deliverUrl);
                                let $file = self.renderFile(template, file);
                                $element.replaceWith($file);
                                $element = $file;
                                self.itemAdded($form);
                            }).fail(function () {
                                let file = new AppFile(null, dbFile.name, AppFile.STATUS_ERROR(), 0);
                                let $file = self.renderFile(template, file);
                                $element.replaceWith($file);
                                $element = $file;
                                self.itemAdded($form);
                            });
                        });
                    },
                    linkType: 'direct',
                    multiselect: true,
                    folderselect: false,
                    sizeLimit: parseInt($dropboxChooser.attr('data-max-file-size')),
                    extensions: JSON.parse($dropboxChooser.attr('data-allowed-extensions')),
                });
            });
        }

        // Google Drive Picker
        let $googleDriveChooser = $('#google-drive-chooser');
        let $googleDriveAuth = $('#google-drive-auth');
        if ($googleDriveChooser.length) {
            const apiKey = 'AIzaSyAkmP25njALQGDsuNF-uy7HP4SzPA8NstY';
            const clientId = '255408880282-aebm3tsuqrq1v0fsh2li8ehpco6ur5bn.apps.googleusercontent.com';
            const scopes = 'https://www.googleapis.com/auth/drive.file';

            let oAuthToken;

            const createPicker = function () {
                const view = new google.picker.DocsView(google.picker.ViewId.DOCS);
                view.setMimeTypes(JSON.parse($googleDriveChooser.attr('data-allowed-extensions')).join(','));
                view.setParent('root');
                view.setIncludeFolders(true);
                const picker = new google.picker.PickerBuilder()
                    .enableFeature(google.picker.Feature.SUPPORT_DRIVES)
                    .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
                    .setAppId('255408880282')
                    .setOAuthToken(oAuthToken)
                    .addView(view)
                    .setDeveloperKey(apiKey)
                    .setCallback(function (data) {
                        if (data.action === google.picker.Action.PICKED) {
                            data.docs.forEach(gdFile => {
                                let $element;
                                $.ajax({
                                    url: $googleDriveChooser.attr('data-url'),
                                    method: 'POST',
                                    dataType: 'json',
                                    contentType: 'application/json',
                                    data: JSON.stringify({
                                        file: gdFile,
                                        state: $('#media-state').val(),
                                        token: oAuthToken,
                                    }),
                                    beforeSend: function () {
                                        let file = new AppFile(null, gdFile.name, AppFile.STATUS_PROGRESS(), null);
                                        $element = self.renderFile(template, file);
                                        $element.prependTo($container);
                                        self.itemAdded($form);
                                    },
                                }).done(function (response) {
                                    let file = new AppFile(response.id, response.name, AppFile.STATUS_SUCCESS(), false, response.custom_properties, response.url_thumb, deleteUrl, deliverUrl);
                                    let $file = self.renderFile(template, file);
                                    $element.replaceWith($file);
                                    $element = $file;
                                    self.itemAdded($form);
                                }).fail(function () {
                                    let file = new AppFile(null, gdFile.name, AppFile.STATUS_ERROR(), 0);
                                    let $file = self.renderFile(template, file);
                                    $element.replaceWith($file);
                                    $element = $file;
                                    self.itemAdded($form);
                                });
                            });
                        }
                    })
                    .build();
                picker.setVisible(true);
            };

            gapi.load('client:auth2:picker', function () {
                gapi.client.init({
                    apiKey: apiKey,
                    discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'],
                    clientId: clientId,
                    scope: scopes,
                }).then(function () {
                    const updateSigninStatus = function (isSignedIn) {
                        if (isSignedIn) {
                            $googleDriveChooser.removeClass('disabled btn-dark').addClass('btn-google-plus');
                            $googleDriveAuth.find('i').addClass('fa-sign-out').removeClass('fa-sign-in');
                            $googleDriveChooser.find('.signed-in').text(gapi.auth2.getAuthInstance().currentUser.get().getBasicProfile().getEmail()).removeClass('d-none');
                            $googleDriveChooser.find('.signed-out').addClass('d-none');

                            oAuthToken = gapi.auth2.getAuthInstance().currentUser.get().getAuthResponse().access_token;
                            gapi.client.setToken({access_token: oAuthToken});
                            $googleDriveChooser.on('click', createPicker);
                            $googleDriveAuth.off('click').on('click', gapi.auth2.getAuthInstance().signOut);
                        } else {
                            $googleDriveChooser.addClass('disabled btn-dark').removeClass('btn-google-plus');
                            $googleDriveAuth.find('i').removeClass('fa-sign-out').addClass('fa-sign-in');
                            $googleDriveChooser.find('.signed-in').addClass('d-none');
                            $googleDriveChooser.find('.signed-out').removeClass('d-none');

                            oAuthToken = null;
                            $googleDriveChooser.off('click');
                            $googleDriveAuth.off('click').on('click', gapi.auth2.getAuthInstance().signIn);
                        }
                    };

                    gapi.auth2.getAuthInstance().isSignedIn.listen(updateSigninStatus);
                    updateSigninStatus(gapi.auth2.getAuthInstance().isSignedIn.get());
                });
            });
        }
    }

    renderFile (template, file) {
        return $(template(file));
    }

    itemAdded ($form) {
        window.app.tooltip.init();
        window.app.asyncImage.initAll();
        this.filterList($form);
    }

    filterList ($form) {
        let $container = $($form.attr('data-file-container'));
        let $listWrapper = $container.parents('.list-wrapper');
        let $filters = $listWrapper.find('[data-filter]');
        let $activeFilter = $filters.filter('.btn-warning').first();
        let $items = $listWrapper.find('.list').children();
        $items.removeClass('d-none');

        let column = $activeFilter.data('column');
        let value = $activeFilter.data('filter');
        if (value && column) {
            $items.each(function () {
                let $item = $(this);
                let $file = $item.find('.image-item');
                if ($file.data(column) !== value) {
                    $item.addClass('d-none');
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/dropzone.js